export default "__VITE_ASSET__a5e5d43a__"